import React, { PureComponent } from 'react';

interface IImageProps {
  imageName: string;
  altText: string;
  extension: string;
  className?: string[];
}

interface IImageState {
  src: string;
  imageName: string;
}

export default class Image extends PureComponent<IImageProps, IImageState> {
  private imageRef: React.MutableRefObject<HTMLImageElement>;

  constructor(props: IImageProps) {
    super(props);
    this.state = {
      src: require(`../../assets/${this.props.imageName}.${this.props.extension}`),
      imageName: this.props.imageName,
    };
    this.imageRef = React.createRef();
  }

  componentDidMount() {
    const src = this.imageRef.current.getAttribute('src');
    if (src.indexOf('$staticlink$') === -1 && src.indexOf('http') !== -1) {
      this.setState({
        ...this.state, src: src,
      });
    }
  }


  render() {
    const { altText, className } = this.props;
    const { src } = this.state;

    return (
      <picture>
        <img
          className={className && className.join(' ')}
          ref={this.imageRef}
          src={src}
          alt={altText}
        />
      </picture>
    );
  }
}
